import { apiRequest } from '@/utils/api-request';
import { WorkflowRunWithResults } from './get-workflow-run';

export interface GetRunBySessionResponse {
  data?: WorkflowRunWithResults;
  detail?: string;
}

/**
 * Fetches a run by session ID. Used as a fallback when WebSocket
 * reconnection is exhausted to determine the actual run status
 * from the backend (which cross-checks PG with Temporal).
 *
 * Does NOT capture to Sentry — this is called in a retry loop and
 * transient failures are expected. The caller handles final failure.
 */
export async function getRunBySession(
  workflowId: string,
  sessionId: string,
  orgId: string,
): Promise<GetRunBySessionResponse> {
  const response = await apiRequest<WorkflowRunWithResults>({
    url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/runs/session/${sessionId}`,
    target: 'workflow',
    method: 'GET',
  });

  if (response?.detail) {
    return { detail: response.detail };
  }

  const data = response.data || response;
  return { data: data as WorkflowRunWithResults };
}
